/**
 * Created by Bart Decorte
 * Date: 11/05/2020
 * Time: 19:07
 */
export default class Filter {
  constructor($root) {
    this.$root = $root;
    this.root = $root.get(0);
  }

  inputs() {
    return [...this.root.querySelectorAll('input, select')];
  }

  setInputState(state) {
    this.inputs().forEach(input => {
      input.disabled = !state;
    });
    return this;
  }

  init() {
    this.setInputState(true);
    return;
  }

  destroy() {
    this.setInputState(false);
    return;
  }

  valueInput() {
    return this.$root.find('.js-value').first();
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/filters/Filter.js